export class FileDropInput {
  constructor(options) {
    const {
      dropZone,
      input,
      onFile,
      validateFile,
      listenForPaste = true,
      dropTarget,
      pasteTarget
    } = options;

    if (!dropZone || !input || typeof onFile !== 'function') {
      throw new Error('FileDropInput requires dropZone, input, and onFile callback.');
    }

    this.dropZone = dropZone;
    this.dropTarget = dropTarget || dropZone;
    this.input = input;
    this.onFile = onFile;
    this.validateFile = validateFile || (() => true);
    this.listenForPaste = listenForPaste;
    this.pasteTarget = pasteTarget || (listenForPaste ? document : null);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handlePaste = this.handlePaste.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this.input.addEventListener('change', this.handleInputChange);
    this.dropTarget.addEventListener('dragenter', this.handleDragOver, false);
    this.dropTarget.addEventListener('dragover', this.handleDragOver, false);
    this.dropTarget.addEventListener('dragleave', this.handleDragLeave, false);
    this.dropTarget.addEventListener('drop', this.handleDrop, false);
    if (this.listenForPaste && this.pasteTarget) {
      this.pasteTarget.addEventListener('paste', this.handlePaste);
    }
  }

  destroy() {
    this.input.removeEventListener('change', this.handleInputChange);
    this.dropTarget.removeEventListener('dragenter', this.handleDragOver);
    this.dropTarget.removeEventListener('dragover', this.handleDragOver);
    this.dropTarget.removeEventListener('dragleave', this.handleDragLeave);
    this.dropTarget.removeEventListener('drop', this.handleDrop);
    if (this.listenForPaste && this.pasteTarget) {
      this.pasteTarget.removeEventListener('paste', this.handlePaste);
    }
  }

  handleInputChange(event) {
    this.processFileList(event.target.files);
    event.target.value = '';
  }

  handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZone.classList.add('drop-zone--active');
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
  }

  handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.dropTarget) {
      this.dropZone.classList.remove('drop-zone--active');
      return;
    }
    const rect = this.dropTarget.getBoundingClientRect();
    const withinBounds =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!withinBounds) {
      this.dropZone.classList.remove('drop-zone--active');
    }
  }

  handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZone.classList.remove('drop-zone--active');
    this.processFileList(event.dataTransfer?.files);
  }

  handlePaste(event) {
    const files = Array.from(event.clipboardData?.files || []);
    const handled = this.processFiles(files);
    if (handled) {
      event.preventDefault();
    }
  }

  processFileList(fileList) {
    if (!fileList) return false;
    return this.processFiles(Array.from(fileList));
  }

  processFiles(files) {
    if (!Array.isArray(files) || !files.length) {
      return false;
    }
    let handled = false;
    files.forEach((file) => {
      if (file && this.validateFile(file)) {
        this.onFile(file);
        handled = true;
      }
    });
    return handled;
  }
}
